import MarketLayoutDescriptors from './_market-layout-descriptors.js'
import FlexPane from './_flex-pane.js'
import Market from './_market.js'
import MiniScoreboard from './_mini-scoreboard.js'
import Participants from './_participants.js'
import KeyValueMap from './_key-value-map.js'

export default {
  name: 'GameLineMarketContent',
  values: {
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {
        categories: {
          TEAM_HDA: {
            selectionTypes: [
              '1',
              '2',
              'X',
            ],
          },
          OVER_EXACTLY_UNDER: {
            selectionTypes: [
              'O',
              'U',
              'TOU',
            ],
          },
        },
      },
    },
    showMarketHeaders: true,
    showParticipants: true,
    showScoreboard: false,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '8px',
        },
      },
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        _mobile_itemSpacing: '2px',
        style: {
          flexBasis: '70%',
          _mobile_flexBasis: '224px',
          _mobile_flexGrow: '0',
        },
      },
    },
    market: {
      configSet: Market,
      configValues: {
        direction: 'column',
        container: {
          createStackingContext: true,
        },
        selectionButton: {
          view: {
            minHeight: '43px',
            layoutDirection: 'horizontalAlignCenter',
            _mobile_layoutDirection: 'vertical',
            nameDisplay: 'hide',
            _mobile_nameDisplay: 'hide',
          },
        },
      },
    },
    scoreboard: {
      configSet: MiniScoreboard,
      configValues: {
        stretch: true,
        showSegmentIndicators: true,
        padding: '20px 0 0 0',
        scoreColumn: {
          margin: 0,
        },
        segmentIndicators: {
          top: -24,
        },
      },
    },
    participants: {
      configSet: Participants,
      configValues: {
        showSeparator: true,
        container: {
          style: {
            flexBasis: '37%',
            padding: '30px 0 0 0',
          },
        },
        text: {
          ellipsisOnLineNumber: 2,
        },
      },
    },
    selectionNameDisplay: {
      configSet: KeyValueMap,
      configValues: {
        TOTAL: 'show shortest',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
